import React, { useState, useEffect } from 'react';
import {
  Box,
  Tab,
  Tabs,
  Typography,
  Breadcrumbs,

  Paper,
  Card,
  CardContent,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Checkbox,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Stack,
  Alert,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Avatar,
  Tooltip,
  CircularProgress,
  Divider,
  useTheme,
  alpha,
  Fade,
  Grid,

  InputAdornment,
  OutlinedInput,
  Popover
} from '@mui/material';

import {
  ArrowBack as ArrowBackIcon
} from '@mui/icons-material';
import { FormattedMessage, useIntl } from 'react-intl';
import CommentCell from './CommentCell';

import { formatDistanceToNow } from 'date-fns';
import {
  Close as CloseIcon,
  CloudUpload as CloudUploadIcon,
  Save as SaveIcon,
  Visibility as VisibilityIcon,
  Edit as EditIcon,
  Warning as WarningIcon,
  CheckCircle as CheckCircleIcon,
  Search as SearchIcon,
  VideoLibrary as VideoIcon,
  Assignment as AssignmentIcon,
  Dashboard as DashboardIcon,
  FilterList as FilterListIcon,
  CalendarToday as CalendarIcon,
  Person as PersonIcon
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import ReactSelect from 'react-select';
import moment from 'moment';
import axios from 'axios';
import AWS from 'aws-sdk';
import { useSelector } from 'react-redux';
import { useAuthToken } from "../TokenContext";
import { useLocation, Link } from 'react-router-dom';
import { useCredentials } from '../useCredentials';
import { region } from 'caniuse-lite';



// AWS Configuration



const MainContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '24px',

  [theme.breakpoints.down('md')]: {
    padding: '16px',
  },

  [theme.breakpoints.down('sm')]: {
    padding: '12px',
  },

  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
}));

const StyledTabs = styled(Tabs)(({ theme }) => ({
  backgroundColor: 'rgba(255,255,255,0.03)',
  borderRadius: '16px',
  padding: '8px',
  marginBottom: '32px',
  border: '1px solid var(--artemy-border)',
  '& .MuiTab-root': {
    minHeight: 48,
    borderRadius: '12px',
    margin: '0 8px',
    textTransform: 'none',
    fontWeight: 600,
    transition: 'all 0.3s ease',
    color: 'var(--artemy-text-secondary)',
    '&.Mui-selected': {
      backgroundColor: 'var(--artemy-primary)',
      color: '#ffffff',
    },
    '&:hover': {
      backgroundColor: 'rgba(var(--artemy-primary-rgb), 0.15)',
      color: 'var(--artemy-primary)',
    },
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
}));

const FilterPaper = styled(Box)(({ theme }) => ({
  padding: '16px 0',
  marginBottom: '24px',
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
  flexWrap: 'wrap',
}));

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  borderRadius: '14px',
  overflow: 'hidden',
  backgroundColor: 'var(--artemy-bg-card)',
  border: '1px solid var(--artemy-border)',
  '& .MuiTableCell-head': {
    backgroundColor: 'rgba(var(--artemy-primary-rgb), 0.1)',
    color: 'var(--artemy-primary)',
    fontWeight: 600,
    fontSize: '0.95rem',
    borderBottom: '1px solid var(--artemy-border)'
  },
  '& .MuiTableCell-body': {
    color: 'var(--artemy-text-primary)',
    borderBottom: '1px solid var(--artemy-border)'
  },
  '& .MuiTableRow-root': {
    transition: 'background-color 0.3s ease',
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.03)',
    },
  },
}));

const StatusChip = styled(Chip)(({ status, theme }) => ({
  '&.blocked': {
    backgroundColor: 'rgba(var(--artemy-red-rgb), 0.1)',
    color: 'var(--artemy-red)',
    borderColor: 'rgba(var(--artemy-red-rgb), 0.5)',
  },
  '&.onTrack': {
    backgroundColor: 'rgba(var(--artemy-green-rgb), 0.1)',
    color: 'var(--artemy-green)',
    borderColor: 'rgba(var(--artemy-green-rgb), 0.5)',
  },
}));

const PodActivityTalent = ({ collapsed }) => {
  const { credentials, isLoaded, isLoading, refresh } = useCredentials();

  AWS.config.update({
    region: credentials.region,
    accessKeyId: credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey
  });
  const s3 = new AWS.S3();
  console.log("config", credentials.region,)
  const theme = useTheme();
  const token = useAuthToken();
  const { user } = useSelector(state => state.auth);
  const intl = useIntl();

  // State
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [uploadDialog, setUploadDialog] = useState(false);
  const [viewDialog, setViewDialog] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [jiraIssues, setJiraIssues] = useState([]);
  const [editDialog, setEditDialog] = useState(false);
  const [editFormData, setEditFormData] = useState(null);
  const [podDetails, setPodDetails] = useState([]);
  // Add this new state for selected pod
  const [selectedPod, setSelectedPod] = useState(null);
  const [selectedPodId, setSelectedPodId] = useState(null);
  const [selectedClientId, setSelectedClientId] = useState(null);
  const location = useLocation();
  const { podid, viewTab } = location.state || {}; // Extract viewTab from location state

  // State - initialize tabValue to 1 if viewTab is true, otherwise 0
  const [tabValue, setTabValue] = useState(viewTab ? 1 : 0);
  useEffect(() => {
    const fetchPodDetails = async () => {
      try {
        const response = await axios.post(
          process.env.REACT_APP_TALENT_PODLISTTALENT,
          { candidateID: user.data[0].c_id },
          { headers: { Authorization: token, 'Content-Type': 'application/json' } }
        );
        const pods = response?.data?.data;
        setPodDetails(pods);

        // Auto-select first pod if available
        if (pods && pods.length > 0) {
          setSelectedPod(pods[0]);
          setSelectedPodId(pods[0].podID);
          setSelectedClientId(pods[0].clientID); // Using podID from your API structure
        }

        setLoading(false);
      } catch (err) {
        console.error("Error:", err);
        setLoading(false);
      }
    };

    fetchPodDetails();
  }, [token, user]);
  const isDark = theme.palette.mode === 'dark';

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: 56,
      backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.palette.background.default,
      borderColor: theme.palette.mode === 'dark' ? alpha(theme.palette.common.white, 0.2) : theme.palette.divider,
      '&:hover': {
        borderColor: theme.palette.primary.main
      }
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.background.paper,
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.4)',
      border: `1px solid ${theme.palette.mode === 'dark' ? alpha(theme.palette.common.white, 0.1) : theme.palette.divider}`,
      zIndex: 9999
    }),
    option: (base, state) => ({
      ...base,
      padding: '8px 12px',
      backgroundColor: state.isSelected
        ? theme.palette.primary.main
        : state.isFocused
          ? (theme.palette.mode === 'dark' ? alpha(theme.palette.common.white, 0.1) : alpha(theme.palette.primary.main, 0.1))
          : 'transparent',
      color: state.isSelected
        ? '#ffffff'
        : theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.text.primary,
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: state.isSelected
          ? theme.palette.primary.main
          : theme.palette.mode === 'dark' ? alpha(theme.palette.common.white, 0.1) : alpha(theme.palette.primary.main, 0.1)
      }
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: theme.palette.mode === 'dark'
        ? alpha(theme.palette.common.white, 0.1)
        : alpha(theme.palette.primary.main, 0.1),
      borderRadius: theme.shape.borderRadius / 2
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.text.primary,
      padding: '2px 6px'
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: theme.palette.mode === 'dark' ? theme.palette.grey[400] : theme.palette.grey[600],
      '&:hover': {
        backgroundColor: theme.palette.mode === 'dark'
          ? alpha(theme.palette.common.white, 0.15)
          : alpha(theme.palette.primary.main, 0.15),
        color: theme.palette.error.main
      }
    }),
    input: (base) => ({
      ...base,
      color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.text.primary
    }),
    placeholder: (base) => ({
      ...base,
      color: theme.palette.mode === 'dark' ? theme.palette.grey[500] : theme.palette.text.secondary
    }),
    noOptionsMessage: (base) => ({
      ...base,
      color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.text.primary
    })
  };

  // Filter states
  const [searchTerm, setSearchTerm] = useState('');
  const [openAITokenDialog, setOpenAITokenDialog] = useState(false);
  const [openAITokenStatus, setOpenAITokenStatus] = useState(null);

  // Add this function to check OpenAI token
  const checkOpenAIToken = async () => {
    try {
      const response = await axios.post(
        'https://rwumymoq6c.execute-api.us-east-1.amazonaws.com/prod/checkOpenai',
        { "Organizational_Code": user.data[0].talent_code },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error('Error checking OpenAI token:', error);
      return { number: 0, data: "Error checking token" };
    }
  };

  // Add this function to handle video upload button click
  const handleVideoUploadClick = async () => {
    const tokenStatus = await checkOpenAIToken();

    if (tokenStatus.number === 0) {
      setOpenAITokenStatus(tokenStatus);
      setOpenAITokenDialog(true);
      return; // Don't open upload dialog
    }

    // If token exists, open the upload dialog
    setUploadDialog(true);
  };
  const [statusFilter, setStatusFilter] = useState('all');
  const [talentFilter, setTalentFilter] = useState([]);
  const [dateRange, setDateRange] = useState({
    start: '',
    end: ''
  });
  // Form state
  const [formData, setFormData] = useState({
    talent_id: user?.data[0]?.c_id || '',
    pod_candidates: user?.data[0]?.firstName || '',
    categories: '',
    today_focus: '',
    blockers: '',
    podID: selectedPodId,
    loom_url: '',
    accomplishments: '',
    jira_issue: [],
    videoFile: null,
    source_language: 'en'
  });

  // Fetch initial data
  useEffect(() => {
    if (selectedPodId) {
      fetchActivities();
      fetchJiraIssues();
      // Update formData with new podID
      setFormData(prev => ({ ...prev, podID: selectedPodId }));
    }
  }, [selectedPodId]);
  // API Functions
  const fetchActivities = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        process.env.REACT_APP_TALENT_PODACTIVITYDASHBORDTALENT,
        {
          talent_id: user.data[0].c_id,
          status: "view_all"
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data?.data?.data) {
        // Make sure each activity has a comments field, even if it's empty
        const activitiesWithComments = response.data.data.data.map(activity => ({
          ...activity,
          comments: activity.comments || '[]'
        }));
        setActivities(activitiesWithComments);
      }
    } catch (error) {
      showSnackbar('Failed to load activities', 'error');
    } finally {
      setLoading(false);
    }
  };
  const handleCommentAdded = (activityId, newComments) => {
    setActivities(prevActivities =>
      prevActivities.map(activity =>
        activity.id === activityId
          ? { ...activity, comments: newComments }
          : activity
      )
    );
  };
  const fetchJiraIssues = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_CLIENT_JIRAISSUESLISTMANAGER,
        {
          pod_id: selectedPodId,
          c_id: user.data[0].c_id
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data.statusCode === 200 && response.data.body) {
        const parsedBody = response.data.body;
        if (Array.isArray(parsedBody.jiraIssues)) {
          setJiraIssues(parsedBody.jiraIssues.map(issue => ({
            value: issue.issue_key,
            label: `${issue.issue_key}: ${issue.issue_summary}`,
            issue_url: issue.issue_url // Add the issue URL
          })));
        }
      }
    } catch (error) {
      showSnackbar('Failed to load Jira issues', 'error');
    }
  };





  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);

      // Handle both array and string formats of jira_issue
      const selectedIssues = Array.isArray(formData.jira_issue)
        ? formData.jira_issue
        : formData.jira_issue.split(',').map(issue => issue.trim());

      // Create combined key:url strings
      const formattedIssues = selectedIssues.map(issue => {
        // If it's already an object with value and issue_url
        if (typeof issue === 'object' && issue.value) {
          return `${issue.value}:${issue.issue_url || ''}`;
        }

        // Find the matching issue from jiraIssues state
        const matchingIssue = jiraIssues.find(ji => ji.value === issue);
        const issueUrl = matchingIssue?.issue_url || `https://your-jira-domain.com/browse/${issue}`;
        return `${issue}:${issueUrl}`;
      }).join(',');

      const payload = {
        talent_id: user?.data[0]?.c_id || '',
        pod_candidates: user?.data[0]?.firstName || '',
        categories: formData.categories,
        today_focus: formData.today_focus,
        blockers: formData.blockers,
        podID: selectedPodId,
        loom_url: formData.loom_url,
        accomplishments: formData.accomplishments,
        jira_issue: formattedIssues, // Combined key:url format
        videoFile: formData.videoFile,
        source_language: formData.source_language,
        blockercheck: formData.blockers ? 1 : 0
      };

      const response = await axios.post(
        process.env.REACT_APP_TALENT_PODACTIVITYTALENT,
        payload,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data.status === 200) {
        showSnackbar('Activity posted successfully', 'success');
        fetchActivities();
        resetForm();
      } else {
        showSnackbar(response.data.data || 'Failed to post activity', 'error');
      }
    } catch (error) {
      console.error('Submit error:', error);
      showSnackbar('Failed to post activity', 'error');
    } finally {
      setLoading(false);
    }
  };

  // Continued in next section...
  // Video Upload Handlers
  const uploadFileToS3 = async (file) => {
    const params = {
      Bucket: process.env.REACT_APP_VIDEOURLBUCKETNAME,
      Key: file.name.replace(/\s/g, ''),
      Body: file,
      ContentType: "video/mp4"
    };
    console.log("bu", process.env.REACT_APP_VIDEOURLBUCKETNAME)
    try {
      const uploadResult = await s3.upload(params).promise();
      return uploadResult.Key;
    } catch (error) {
      throw new Error('Failed to upload file to S3');
    }
  };

  const handleVideoUpload = async () => {
    if (!formData.videoFile) {
      showSnackbar('Please select a video file', 'error');
      return;
    }

    // Check OpenAI token before proceeding with upload
    const tokenStatus = await checkOpenAIToken();

    if (tokenStatus.number === 0) {
      setOpenAITokenStatus(tokenStatus);
      setOpenAITokenDialog(true);
      return; // Don't proceed with upload
    }

    try {
      setUploadLoading(true);
      const fileName = await uploadFileToS3(formData.videoFile);
      const loomUrl = `https://${process.env.REACT_APP_VIDEOURLBUCKETNAME}.s3.amazonaws.com/${fileName}`;

      const transcribePayload = {
        file_name: fileName,
        created_by: user.data[0].c_id,
        pod_id: selectedPodId,
        source_language: formData.source_language,
        target_language: "en",
        posted_to: selectedClientId,
        loom_url: loomUrl,
        categories: formData.categories,
        pod_candidates: user.data[0].firstName
      };
      console.log(transcribePayload)
      const response = await axios.post(
        process.env.REACT_APP_TALENT_TRANSCRIBEPOC,
        transcribePayload,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data.statusCode === 200) {
        setFormData(prev => ({ ...prev, loom_url: loomUrl }));
        showSnackbar('Video uploaded successfully', 'success');
        setUploadDialog(false);
      }
    } catch (error) {
      showSnackbar('Failed to upload video', 'error');
    } finally {
      setUploadLoading(false);
    }
  };

  const handlePlayVideo = async (loomUrl) => {
    try {
      const filename = loomUrl.split('/').pop();
      const cloudFrontUrl = `${process.env.REACT_APP_CLOUDFRONTs3}${filename}`;

      const response = await axios.post(
        process.env.REACT_APP_TALENT_CLOUDFRONTAPI,
        { url: cloudFrontUrl }
      );

      const signedUrl = JSON.parse(response.data.body).signedUrl;
      if (signedUrl) {
        window.open(signedUrl, '_blank');
      }
    } catch (error) {
      showSnackbar('Error accessing video', 'error');
    }
  };

  // Filter Functions
  const getFilteredActivities = () => {
    return activities.filter(activity => {
      const matchesSearch =
        activity.today_focus?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        activity.pod_candidates?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        activity.jira_issue?.toLowerCase().includes(searchTerm.toLowerCase());

      const matchesStatus =
        statusFilter === 'all' ||
        (statusFilter === 'blocked' ? !!activity.blockers : !activity.blockers);

      // Updated talent filtering logic for multiple selections
      const matchesTalent =
        talentFilter.length === 0 ||
        talentFilter.some(talent => talent.value === activity.pod_candidates);

      const activityDate = moment(activity.createdAt);
      const matchesDate =
        (!dateRange.start || activityDate.isSameOrAfter(moment(dateRange.start), 'day')) &&
        (!dateRange.end || activityDate.isSameOrBefore(moment(dateRange.end), 'day'));

      return matchesSearch && matchesStatus && matchesTalent && matchesDate;
    });
  };

  // Helper Functions
  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({ open: true, message, severity });
  };

  const resetForm = () => {
    setFormData({
      talent_id: user?.data[0]?.c_id || '',
      pod_candidates: user?.data[0]?.firstName || '',
      categories: '',
      today_focus: '',
      blockers: '',
      podID: '',
      loom_url: '',
      accomplishments: '',
      jira_issue: [],
      videoFile: null,
      source_language: 'en'
    });
  };
  const getUniqueTalents = () => {
    const uniqueTalents = new Set();
    activities.forEach(activity => {
      if (activity.pod_candidates) {
        uniqueTalents.add(activity.pod_candidates);
      }
    });
    return Array.from(uniqueTalents)
      .sort()
      .map(talent => ({
        value: talent,
        label: talent
      }));
  };
  const renderPodSelector = () => (
    <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap', marginBottom: '24px' }}>
      <div style={{ minWidth: 300, display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <label style={{ fontSize: '13px', color: 'var(--artemy-text-secondary)', fontWeight: 500 }}>
          {intl.formatMessage({ id: 'selectPod', defaultMessage: 'Select Pod' })}
        </label>
        <div style={{ position: 'relative' }}>
          <div style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', display: 'flex', color: 'var(--artemy-text-dim)' }}>
            <DashboardIcon fontSize="small" />
          </div>
          <select
            className="artemy-input"
            value={selectedPodId || ''}
            onChange={(e) => {
              const selectedId = e.target.value;
              const pod = podDetails.find(p => p.podID === selectedId);
              const clientID = podDetails.find(p => p.clientID === selectedId)
              setSelectedPod(pod);
              setSelectedPodId(selectedId);
              setSelectedClientId(clientID);
            }}
            style={{ width: '100%', paddingLeft: '40px' }}
          >
            <option value="" disabled>Select a Pod</option>
            {podDetails.map((pod) => (
              <option key={pod.podID} value={pod.podID} style={{ background: '#000' }}>
                {pod.podName} {pod.status === 'Active' ? '(Active)' : ''}
              </option>
            ))}
          </select>
        </div>
      </div>

      {selectedPod && (
        <span style={{ marginTop: '26px', fontSize: 12, padding: '6px 12px', borderRadius: 20, display: 'inline-flex', alignItems: 'center', gap: 6, color: 'var(--artemy-primary)', border: '1px solid rgba(var(--artemy-primary-rgb), 0.3)' }}>
          Selected: {selectedPod.podName}
        </span>
      )}
    </div>
  );

  // Render Functions
  const renderFilters = () => (
    <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-end', flexWrap: 'wrap', padding: '16px 0', marginBottom: '24px' }}>
      <div style={{ position: 'relative', minWidth: 200 }}>
        <div style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', display: 'flex', color: 'var(--artemy-text-dim)' }}>
          <SearchIcon fontSize="small" />
        </div>
        <input
          type="text"
          className="artemy-input"
          placeholder={intl.formatMessage({ id: 'search' })}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ width: '100%', paddingLeft: '40px' }}
        />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        <label style={{ fontSize: '11px', color: 'var(--artemy-text-secondary)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{intl.formatMessage({ id: 'startDate' })}</label>
        <input
          type="date"
          className="artemy-input"
          value={dateRange.start}
          onChange={(e) => setDateRange(prev => ({ ...prev, start: e.target.value }))}
          style={{ minWidth: 150 }}
        />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        <label style={{ fontSize: '11px', color: 'var(--artemy-text-secondary)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{intl.formatMessage({ id: 'endDate' })}</label>
        <input
          type="date"
          className="artemy-input"
          value={dateRange.end}
          onChange={(e) => setDateRange(prev => ({ ...prev, end: e.target.value }))}
          style={{ minWidth: 150 }}
        />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, minWidth: 150 }}>
        <label style={{ fontSize: '11px', color: 'var(--artemy-text-secondary)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{intl.formatMessage({ id: 'status' })}</label>
        <select
          className="artemy-input"
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          style={{ width: '100%' }}
        >
          <option style={{ background: '#000' }} value="all">{intl.formatMessage({ id: 'allStatus' })}</option>
          <option style={{ background: '#000' }} value="blocked">{intl.formatMessage({ id: 'blocked' })}</option>
          <option style={{ background: '#000' }} value="onTrack">{intl.formatMessage({ id: 'onTrack' })}</option>
        </select>
      </div>

      <Box sx={{ minWidth: 200, flex: 1 }}>
        <ReactSelect
          isMulti
          value={talentFilter}
          options={getUniqueTalents()}
          onChange={(selected) => setTalentFilter(selected || [])}
          placeholder={intl.formatMessage({ id: 'selectTalents' })}
          formatOptionLabel={({ value, label }) => (
            <Stack direction="row" spacing={1} alignItems="center">
              <Avatar sx={{ width: 24, height: 24, fontSize: '0.75rem' }}>
                {label[0]}
              </Avatar>
              <Typography variant="body2">{label}</Typography>
            </Stack>
          )}
          styles={customStyles}
        />
      </Box>
    </div>
  );


  // Handle edit submission

  // Helper function to format Jira issues
  const formatJiraIssues = (jiraIssueData) => {
    try {
      // If it's already in the correct format, return as is
      if (Array.isArray(jiraIssueData) && jiraIssueData.every(issue => issue.value && issue.label)) {
        return jiraIssueData;
      }

      // If it's a string, split and format
      if (typeof jiraIssueData === 'string' && jiraIssueData.length > 0) {
        return jiraIssueData.split(',').map(issue => ({
          value: issue.trim(),
          label: issue.trim()
        }));
      }

      // If it's an array but not in the correct format
      if (Array.isArray(jiraIssueData)) {
        return jiraIssueData.map(issue => {
          if (typeof issue === 'string') {
            return {
              value: issue.trim(),
              label: issue.trim()
            };
          }
          return issue;
        });
      }

      // Return empty array if no valid input
      return [];
    } catch (error) {
      console.error('Error formatting Jira issues:', error);
      return [];
    }
  };
  // Update the renderViewDialog function
  const renderViewDialog = () => (
    <Dialog
      open={viewDialog}
      onClose={() => setViewDialog(false)}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: { borderRadius: theme.shape.borderRadius * 2 }
      }}
    >
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">{intl.formatMessage({ id: 'activityDetails' })}</Typography>
          <Stack direction="row" spacing={1}>
            <IconButton
              onClick={() => {
                setEditFormData({
                  ...selectedActivity,
                  jira_issue: formatJiraIssues(selectedActivity.jira_issue)
                });
                setViewDialog(false);
                setEditDialog(true);
              }}
              color="primary"
            >
              <EditIcon />
            </IconButton>
            <IconButton onClick={() => setViewDialog(false)}>
              <CloseIcon />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        {selectedActivity && (
          <Stack spacing={3}>
            <Box>
              <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: 'date' })}</Typography>
              <Typography>{moment(selectedActivity.createdAt).format('MMMM DD, YYYY')}</Typography>
            </Box>

            <Box>
              <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: 'talent' })}</Typography>
              <Stack direction="row" spacing={1} alignItems="center">
                <Avatar>{selectedActivity.pod_candidates?.[0]}</Avatar>
                <Typography>{selectedActivity.pod_candidates}</Typography>
              </Stack>
            </Box>

            <Box>
              <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: 'jiraIssues' })}</Typography>
              <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mt: 1 }}>
                {formatJiraIssues(selectedActivity.jira_issue).map((issue, index) => (
                  <Chip
                    key={index}
                    label={issue.value || issue.label || issue}
                    variant="outlined"
                    size="small"
                  />
                ))}
              </Stack>
            </Box>

            <Box>
              <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: 'todaysFocus' })}</Typography>
              <Typography sx={{ whiteSpace: 'pre-wrap' }}>{selectedActivity.today_focus}</Typography>
            </Box>

            {selectedActivity.accomplishments && (
              <Box>
                <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: 'accomplishments' })}</Typography>
                <Typography sx={{ whiteSpace: 'pre-wrap' }}>{selectedActivity.accomplishments}</Typography>
              </Box>
            )}

            {selectedActivity.blockers && (
              <Box>
                <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: 'blockers' })}</Typography>
                <Typography sx={{ whiteSpace: 'pre-wrap' }}>{selectedActivity.blockers}</Typography>
              </Box>
            )}

            {selectedActivity.loom_url && (
              <Box>
                <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: 'videoUpdate' })}</Typography>
                <Button
                  startIcon={<VideoIcon />}
                  variant="outlined"
                  onClick={() => handlePlayVideo(selectedActivity.loom_url)}
                  sx={{ mt: 1 }}
                >
                  View Video
                </Button>
              </Box>
            )}
            <Box>
              <Typography variant="subtitle2" color="textSecondary">{intl.formatMessage({ id: 'comments' })}</Typography>
              <Box mt={1}>
                <CommentCell
                  comments={selectedActivity.comments || '[]'}
                  activity_id={selectedActivity.id}
                  onCommentAdded={(id, newComments) => {
                    // Update the selected activity with new comments
                    setSelectedActivity(prev => ({
                      ...prev,
                      comments: newComments
                    }));
                    // Also update in the main activities list
                    handleCommentAdded(id, newComments);
                  }}
                />
              </Box>
            </Box>
          </Stack>
        )}
      </DialogContent>
    </Dialog>
  );



  // Update the handleOpenEdit function
  const handleOpenEdit = (activity) => {
    if (!activity || !activity.id) {
      console.error('Invalid activity data:', activity);
      showSnackbar('Invalid activity data', 'error');
      return;
    }

    // First fetch Jira issues to ensure we have the latest data
    fetchJiraIssues().then(() => {
      try {
        // Format the Jira issues with proper error handling
        const formattedJiraIssues = formatJiraIssues(activity.jira_issue);

        // Map to full Jira issue data if available
        const jiraIssueArray = formattedJiraIssues.map(issue => {
          const matchingIssue = jiraIssues.find(ji => ji.value === issue.value);
          return matchingIssue || issue;
        });

        // Set the edit form data
        setEditFormData({
          id: activity.id,
          // talent_id: activity.talent_id || user?.data[0]?.c_id,
          // pod_candidates: activity.pod_candidates || user?.data[0]?.firstName,
          jira_issue: jiraIssueArray,
          today_focus: activity.today_focus || '',
          accomplishments: activity.accomplishments || '',
          blockers: activity.blockers || '',
          // podID: activity.podID || '',
          loom_url: activity.loom_url || '',
          categories: activity.categories || '',
          // createdAt: activity.createdAt
        });

        setEditDialog(true);
      } catch (error) {
        console.error('Error processing activity data:', error);
        showSnackbar('Error processing activity data', 'error');
      }
    }).catch(error => {
      console.error('Error fetching Jira issues:', error);
      showSnackbar('Failed to load Jira issues', 'error');
    });
  };

  // Update handleEditSubmit to use the same formatting
  const handleEditSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      // Safely handle jira_issue formatting with null checks
      let formattedIssues = '';

      if (editFormData.jira_issue) {
        // Handle different possible formats of jira_issue
        const issueArray = Array.isArray(editFormData.jira_issue)
          ? editFormData.jira_issue
          : typeof editFormData.jira_issue === 'string'
            ? editFormData.jira_issue.split(',')
            : [];

        formattedIssues = issueArray
          .filter(issue => issue) // Remove any null/undefined values
          .map(issue => {
            if (typeof issue === 'object' && issue.value) {
              return `${issue.value}:${issue.issue_url || ''}`;
            }
            // Handle string case
            const issueKey = typeof issue === 'string' ? issue.trim() : issue;
            const matchingIssue = jiraIssues.find(ji => ji.value === issueKey);
            const issueUrl = matchingIssue?.issue_url || `https://your-jira-domain.com/browse/${issueKey}`;
            return `${issueKey}:${issueUrl}`;
          })
          .join(',');
      }

      // Format the payload
      const payload = {
        id: editFormData.id,
        talent_id: user?.data[0]?.c_id,
        pod_candidates: user?.data[0]?.firstName,
        jira_issue: formattedIssues,
        today_focus: editFormData.today_focus,
        accomplishments: editFormData.accomplishments || '',
        blockers: editFormData.blockers || '',
        blockercheck: editFormData.blockers ? 1 : 0,
        podID: editFormData.podID || '',
        loom_url: editFormData.loom_url || '',
        categories: editFormData.categories || '',
        status: 'update'
      };

      console.log('Edit payload:', payload); // For debugging

      const response = await axios({
        method: 'post',
        url: process.env.REACT_APP_TALENT_PODACTIVITYUPDATETALENT,
        data: payload,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.data.status === 200) {
        showSnackbar('Activity updated successfully', 'success');
        await fetchActivities();
        setEditDialog(false);
        setEditFormData(null);
      } else {
        throw new Error(response.data.message || 'Failed to update activity');
      }
    } catch (error) {
      console.error('Edit submission error:', error);
      showSnackbar(error.response?.data?.message || error.message || 'Failed to update activity', 'error');
    } finally {
      setLoading(false);
    }
  };
  // Make sure the edit form correctly binds all fields
  const renderEditDialog = () => (
    <Dialog
      open={editDialog}
      onClose={() => setEditDialog(false)}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: { borderRadius: theme.shape.borderRadius * 2 }
      }}
    >
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">{intl.formatMessage({ id: 'edit' })}</Typography>
          <IconButton onClick={() => setEditDialog(false)}>
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <form onSubmit={handleEditSubmit}>
        <DialogContent dividers>
          {editFormData && (
            <Stack spacing={3}>
              <FormControl fullWidth>
                <ReactSelect
                  isMulti
                  value={editFormData.jira_issue}
                  options={jiraIssues}
                  onChange={(selected) => setEditFormData(prev => ({
                    ...prev,
                    jira_issue: selected || []
                  }))}
                  placeholder={intl.formatMessage({ id: 'selectJiraIssues' })}
                  styles={customStyles}
                />
              </FormControl>

              <TextField
                label={intl.formatMessage({ id: 'todaysFocus' })}
                multiline
                rows={4}
                value={editFormData.today_focus || ''}
                onChange={(e) => setEditFormData(prev => ({
                  ...prev,
                  today_focus: e.target.value
                }))}
                required
              />

              <TextField
                label={intl.formatMessage({ id: 'accomplishments' })}
                multiline
                rows={4}
                value={editFormData.accomplishments || ''}
                onChange={(e) => setEditFormData(prev => ({
                  ...prev,
                  accomplishments: e.target.value
                }))}
              />

              {editFormData.blockers ? (
                <Box sx={{ mt: 2 }}>
                  <Typography variant="subtitle2" gutterBottom sx={{
                    color: theme => theme.palette.mode === 'dark' ? '#e2e8f0' : '#1e293b'
                  }}>
                    {intl.formatMessage({ id: 'blockerDetails' })}
                  </Typography>
                  <Typography variant="body2" sx={{
                    p: 2,
                    bgcolor: theme => theme.palette.mode === 'dark'
                      ? 'rgba(30, 41, 59, 0.6)'
                      : 'grey.100',
                    borderRadius: 1,
                    whiteSpace: 'pre-wrap',
                    color: theme => theme.palette.mode === 'dark' ? '#cbd5e1' : 'text.secondary',
                    border: theme => theme.palette.mode === 'dark'
                      ? '1px solid rgba(99, 102, 241, 0.2)'
                      : '1px solid rgba(0, 0, 0, 0.12)'
                  }}>
                    {editFormData.blockers}
                  </Typography>
                  <Typography variant="caption" sx={{
                    display: 'block',
                    mt: 1,
                    color: theme => theme.palette.mode === 'dark' ? '#ccdff7ff' : 'primary.main',
                    fontStyle: 'italic'
                  }}>
                    To Edit Blocker Visit TaskDetails Screen
                  </Typography>
                </Box>
              ) : (
                <Typography variant="caption" sx={{
                  display: 'block',
                  mt: 2,
                  color: theme => theme.palette.mode === 'dark' ? '#d4e2f4ff' : 'primary.main',
                  fontStyle: 'italic'
                }}>
                  To Edit Blocker Visit TaskDetails Screen
                </Typography>
              )}

            </Stack>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 3 }}>
          <Button onClick={() => setEditDialog(false)}>{intl.formatMessage({ id: 'cancel' })}</Button>
          <Button
            type="submit"
            variant="contained"
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} /> : <SaveIcon />}
          >
            {intl.formatMessage({ id: 'saveChanges' })}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
  const renderJiraIssues = (jiraIssueString) => {
    if (!jiraIssueString) return [];

    // Helper function to parse key:url format
    const parseIssueString = (issueStr) => {
      // Find the first occurrence of ':' to split key and url
      const firstColonIndex = issueStr.indexOf(':');
      if (firstColonIndex === -1) return { key: issueStr.trim(), url: '' };

      const key = issueStr.substring(0, firstColonIndex).trim();
      const url = issueStr.substring(firstColonIndex + 1).trim();

      return { key, url };
    };

    // Handle different input formats
    const issues = typeof jiraIssueString === 'string'
      ? jiraIssueString.split(',').map(parseIssueString)
      : Array.isArray(jiraIssueString)
        ? jiraIssueString.map(issue => {
          if (typeof issue === 'string') {
            return parseIssueString(issue);
          }
          return {
            key: issue.value || '',
            url: issue.issue_url || ''
          };
        })
        : [];

    return issues.map((issue, index) => {
      const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (issue.url) {
          // For debugging
          console.log('Opening URL:', issue.url);
          window.open(issue.url, '_blank', 'noopener,noreferrer');
        }
      };

      return (
        <Tooltip title={`Click to open ${issue.key} in Jira`} key={index}>
          <Chip
            label={issue.key}
            size="small"
            variant="outlined"
            clickable
            onClick={handleClick}
            sx={{
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: theme.palette.mode === 'dark'
                  ? alpha(theme.palette.primary.main, 0.2)
                  : alpha(theme.palette.primary.main, 0.1)
              }
            }}
          />
        </Tooltip>
      );
    });
  };
  // OpenAI Token Warning Dialog
  const renderOpenAITokenDialog = () => (
    <Dialog
      open={openAITokenDialog}
      onClose={() => setOpenAITokenDialog(false)}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: theme.shape.borderRadius * 2 }
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={2}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              backgroundColor: 'warning.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <WarningIcon sx={{ color: 'white' }} />
          </Box>
          <Typography variant="h6">OpenAI Token Required</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Please contact your manager to update the OpenAI token in the settings page.
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', mt: 3 }}>
          <Button
            variant="outlined"
            onClick={() => setOpenAITokenDialog(false)}
          >
            Cancel
          </Button>
          {/* <Button 
          variant="contained" 
          color="primary"
          onClick={() => {
            window.open('/settings', '_blank'); // Change this to your actual settings page route
            setOpenAITokenDialog(false);
          }}
        >
          Go to Settings
        </Button> */}
        </Box>
      </DialogContent>
    </Dialog>
  );

  const renderActivitiesTable = () => {
    const filteredActivities = getFilteredActivities();

    return (
      <div className="artemy-card" style={{ overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr>
              <th style={{ textAlign: 'left', padding: '12px 16px', fontFamily: 'var(--artemy-font-mono)', fontSize: 10, letterSpacing: '.8px', color: 'var(--artemy-text-dim)', textTransform: 'uppercase', borderBottom: '1px solid var(--artemy-border)', fontWeight: 400 }}>
                {intl.formatMessage({ id: 'date', defaultMessage: 'Date' })}
              </th>
              <th style={{ textAlign: 'left', padding: '12px 16px', fontFamily: 'var(--artemy-font-mono)', fontSize: 10, letterSpacing: '.8px', color: 'var(--artemy-text-dim)', textTransform: 'uppercase', borderBottom: '1px solid var(--artemy-border)', fontWeight: 400 }}>
                {intl.formatMessage({ id: 'talent', defaultMessage: 'Talent' })}
              </th>
              <th style={{ textAlign: 'left', padding: '12px 16px', fontFamily: 'var(--artemy-font-mono)', fontSize: 10, letterSpacing: '.8px', color: 'var(--artemy-text-dim)', textTransform: 'uppercase', borderBottom: '1px solid var(--artemy-border)', fontWeight: 400 }}>
                {intl.formatMessage({ id: 'jiraIssues', defaultMessage: 'Jira Issues' })}
              </th>
              <th style={{ textAlign: 'left', padding: '12px 16px', fontFamily: 'var(--artemy-font-mono)', fontSize: 10, letterSpacing: '.8px', color: 'var(--artemy-text-dim)', textTransform: 'uppercase', borderBottom: '1px solid var(--artemy-border)', fontWeight: 400 }}>
                {intl.formatMessage({ id: 'focus', defaultMessage: 'Focus' })}
              </th>
              <th style={{ textAlign: 'left', padding: '12px 16px', fontFamily: 'var(--artemy-font-mono)', fontSize: 10, letterSpacing: '.8px', color: 'var(--artemy-text-dim)', textTransform: 'uppercase', borderBottom: '1px solid var(--artemy-border)', fontWeight: 400 }}>
                {intl.formatMessage({ id: 'status', defaultMessage: 'Status' })}
              </th>
              <th style={{ textAlign: 'left', padding: '12px 16px', fontFamily: 'var(--artemy-font-mono)', fontSize: 10, letterSpacing: '.8px', color: 'var(--artemy-text-dim)', textTransform: 'uppercase', borderBottom: '1px solid var(--artemy-border)', fontWeight: 400 }}>
                {intl.formatMessage({ id: 'comments', defaultMessage: 'Comments' })}
              </th>
              <th style={{ textAlign: 'left', padding: '12px 16px', fontFamily: 'var(--artemy-font-mono)', fontSize: 10, letterSpacing: '.8px', color: 'var(--artemy-text-dim)', textTransform: 'uppercase', borderBottom: '1px solid var(--artemy-border)', fontWeight: 400 }}>
                {intl.formatMessage({ id: 'actions', defaultMessage: 'Actions' })}
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredActivities?.map((activity) => (
              <tr key={activity.id} style={{ borderBottom: '1px solid rgba(255,255,255,.03)', transition: 'background .15s' }}>
                <td style={{ padding: '12px 16px', fontWeight: 500, color: 'var(--artemy-text-primary)' }}>
                  {moment(activity.createdAt).format('MMM DD, YYYY')}
                </td>
                <td style={{ padding: '12px 16px' }}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Avatar sx={{ width: 24, height: 24, fontSize: '0.75rem', bgcolor: 'var(--artemy-primary)' }}>
                      {activity.pod_candidates?.[0]}
                    </Avatar>
                    <span style={{ fontSize: 13, color: 'var(--artemy-text-primary)' }}>
                      {activity.pod_candidates}
                    </span>
                  </Stack>
                </td>
                <td style={{ padding: '12px 16px' }}>
                  <Stack direction="row" spacing={1} flexWrap="wrap">
                    {renderJiraIssues(activity.jira_issue)}
                  </Stack>
                </td>
                <td style={{ padding: '12px 16px' }}>
                  <Tooltip title={activity.today_focus}>
                    <div style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: 13, color: 'var(--artemy-text-secondary)' }}>
                      {activity.today_focus}
                    </div>
                  </Tooltip>
                </td>
                <td style={{ padding: '12px 16px' }}>
                  <span style={{ fontSize: 12, padding: '4px 8px', borderRadius: 4, display: 'inline-flex', alignItems: 'center', gap: 4, color: activity.blockers ? 'var(--artemy-red)' : 'var(--artemy-green)', background: activity.blockers ? 'rgba(255,77,106,.1)' : 'rgba(0,212,170,.1)' }}>
                    {activity.blockers ? <WarningIcon sx={{ fontSize: 14 }} /> : <CheckCircleIcon sx={{ fontSize: 14 }} />}
                    {activity.blockers ? 'Blocked' : 'On Track'}
                  </span>
                </td>
                <td style={{ padding: '12px 16px' }}>
                  <CommentCell
                    comments={activity.comments || '[]'}
                    activity_id={activity.id}
                    onCommentAdded={handleCommentAdded}
                  />
                </td>
                <td style={{ padding: '12px 16px' }}>
                  <Stack direction="row" spacing={1}>
                    <Tooltip title="View Details">
                      <IconButton
                        size="small"
                        onClick={() => {
                          setSelectedActivity(activity);
                          setViewDialog(true);
                        }}
                        sx={{ color: 'var(--artemy-text-secondary)', '&:hover': { color: 'var(--artemy-text-primary)' } }}
                      >
                        <VisibilityIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Edit">
                      <IconButton
                        size="small"
                        onClick={() => handleOpenEdit(activity)}
                        sx={{ color: 'var(--artemy-text-secondary)', '&:hover': { color: 'var(--artemy-text-primary)' } }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    {activity.loom_url && (
                      <Tooltip title="View Video">
                        <IconButton
                          size="small"
                          onClick={() => handlePlayVideo(activity.loom_url)}
                          sx={{ color: 'var(--artemy-primary)' }}
                        >
                          <VideoIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Stack>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  // Continue with the rest of your component's JSX...
  // Render Activity Form
  const renderActivityForm = () => {

    // OpenAI Token Warning Dialog

    return (
      <div className="artemy-card" style={{ padding: '32px' }}>
        <Typography variant="h6" gutterBottom color="primary" sx={{ fontWeight: 600, fontSize: '18px' }}>
          <FormattedMessage id="newActivityUpdate" defaultMessage="New Activity Update" />
        </Typography>
        <div style={{ height: '1px', background: 'var(--artemy-border)', margin: '24px 0' }} />

        <form onSubmit={handleSubmit}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
            <div>
              <ReactSelect
                isMulti
                value={formData.jira_issue}
                options={jiraIssues}
                onChange={(selected) => setFormData(prev => ({ ...prev, jira_issue: selected }))}
                placeholder={intl.formatMessage({ id: 'selectJiraIssues', defaultMessage: 'Select Jira Issues' })}
                components={{
                  DropdownIndicator: () => null,
                  IndicatorSeparator: () => null
                }}
                styles={customStyles}
              />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <label style={{ fontSize: '13px', color: 'var(--artemy-text-secondary)', fontWeight: 500 }}>
                {intl.formatMessage({ id: 'todaysFocus', defaultMessage: "Today's Focus" })} <span style={{ color: 'var(--artemy-red)' }}>*</span>
              </label>
              <textarea
                className="artemy-input"
                style={{ width: '100%', minHeight: '100px', padding: '12px', resize: 'vertical' }}
                required
                value={formData.today_focus}
                onChange={(e) => setFormData(prev => ({ ...prev, today_focus: e.target.value }))}
              />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <label style={{ fontSize: '13px', color: 'var(--artemy-text-secondary)', fontWeight: 500 }}>
                {intl.formatMessage({ id: 'accomplishments', defaultMessage: 'Accomplishments' })}
              </label>
              <textarea
                className="artemy-input"
                style={{ width: '100%', minHeight: '100px', padding: '12px', resize: 'vertical' }}
                value={formData.accomplishments}
                onChange={(e) => setFormData(prev => ({ ...prev, accomplishments: e.target.value }))}
              />
            </div>

            <FormControlLabel
              control={
                <Checkbox
                  checked={!!formData.blockers}
                  onChange={(e) => setFormData(prev => ({ ...prev, blockers: e.target.checked ? '' : null }))}
                  sx={{ color: 'var(--artemy-primary)', '&.Mui-checked': { color: 'var(--artemy-primary)' } }}
                />
              }
              label={
                <span style={{ fontSize: '13px', color: 'var(--artemy-text-secondary)' }}>
                  <FormattedMessage id="addBlocker" defaultMessage="Add Blocker Information" />
                </span>
              }
            />

            {formData.blockers !== null && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <label style={{ fontSize: '13px', color: 'var(--artemy-text-secondary)', fontWeight: 500 }}>
                  {intl.formatMessage({ id: 'blockerDetails', defaultMessage: 'Blocker Details' })}
                </label>
                <textarea
                  className="artemy-input"
                  style={{ width: '100%', minHeight: '80px', padding: '12px', resize: 'vertical' }}
                  value={formData.blockers || ''}
                  onChange={(e) => setFormData(prev => ({ ...prev, blockers: e.target.value }))}
                />
              </div>
            )}

            <button
              type="button"
              className="artemy-btn artemy-btn-ghost"
              onClick={handleVideoUploadClick}
              style={{ padding: '10px 16px', border: '1px solid var(--artemy-border)', justifyContent: 'center' }}
            >
              <VideoIcon sx={{ fontSize: 18 }} />
              <FormattedMessage id="addVideoUpdate" defaultMessage="Add Video Update" />
            </button>

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
              <button
                type="submit"
                disabled={loading}
                className="artemy-btn"
                style={{ padding: '12px 24px', background: 'var(--artemy-primary)', color: '#fff', fontSize: '14px', borderRadius: '8px' }}
              >
                {loading ? <CircularProgress size={20} sx={{ color: '#fff', mr: 1 }} /> : <SaveIcon sx={{ fontSize: 18, mr: 1 }} />}
                {loading ? (
                  <FormattedMessage id="posting" defaultMessage="Posting..." />
                ) : (
                  <FormattedMessage id="postActivity" defaultMessage="Post Activity" />
                )}
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  };

  // Video Upload Dialog
  const renderUploadDialog = () => (
    <Dialog
      open={uploadDialog}
      onClose={() => setUploadDialog(false)}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: theme.shape.borderRadius * 2 }
      }}
    >
      <DialogTitle>
        Upload Video Update
        <IconButton
          onClick={() => setUploadDialog(false)}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ mt: 2 }}>
          <FormControl fullWidth>
            <InputLabel>Category</InputLabel>
            <Select
              value={formData.categories}
              onChange={(e) => setFormData(prev => ({ ...prev, categories: e.target.value }))}
              label="Category"
            >
              <MenuItem value="Design">Design</MenuItem>
              <MenuItem value="Development">Development</MenuItem>
              <MenuItem value="Testing">Testing</MenuItem>
              <MenuItem value="Bug Fix">Bug Fix</MenuItem>
              <MenuItem value="Documentation">Documentation</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel>Language</InputLabel>
            <Select
              value={formData.source_language}
              onChange={(e) => setFormData(prev => ({ ...prev, source_language: e.target.value }))}
              label="Language"
            >
              <MenuItem value="ab">Abkhazian</MenuItem>
              <MenuItem value="aa">Afar</MenuItem>
              <MenuItem value="af">Afrikaans</MenuItem>
              <MenuItem value="ak">Akan</MenuItem>
              <MenuItem value="sq">Albanian</MenuItem>
              <MenuItem value="am">Amharic</MenuItem>
              <MenuItem value="ar">Arabic</MenuItem>
              <MenuItem value="an">Aragonese</MenuItem>
              <MenuItem value="hy">Armenian</MenuItem>
              <MenuItem value="as">Assamese</MenuItem>
              <MenuItem value="av">Avaric</MenuItem>
              <MenuItem value="ae">Avestan</MenuItem>
              <MenuItem value="ay">Aymara</MenuItem>
              <MenuItem value="az">Azerbaijani</MenuItem>
              <MenuItem value="bm">Bambara</MenuItem>
              <MenuItem value="ba">Bashkir</MenuItem>
              <MenuItem value="eu">Basque</MenuItem>
              <MenuItem value="be">Belarusian</MenuItem>
              <MenuItem value="bn">Bengali</MenuItem>
              <MenuItem value="bi">Bislama</MenuItem>
              <MenuItem value="bs">Bosnian</MenuItem>
              <MenuItem value="br">Breton</MenuItem>
              <MenuItem value="bg">Bulgarian</MenuItem>
              <MenuItem value="my">Burmese</MenuItem>
              <MenuItem value="ca">Catalan</MenuItem>
              <MenuItem value="ch">Chamorro</MenuItem>
              <MenuItem value="ce">Chechen</MenuItem>
              <MenuItem value="ny">Chichewa</MenuItem>
              <MenuItem value="zh">Chinese</MenuItem>
              <MenuItem value="cv">Chuvash</MenuItem>
              <MenuItem value="kw">Cornish</MenuItem>
              <MenuItem value="co">Corsican</MenuItem>
              <MenuItem value="cr">Cree</MenuItem>
              <MenuItem value="hr">Croatian</MenuItem>
              <MenuItem value="cs">Czech</MenuItem>
              <MenuItem value="da">Danish</MenuItem>
              <MenuItem value="dv">Divehi</MenuItem>
              <MenuItem value="nl">Dutch</MenuItem>
              <MenuItem value="dz">Dzongkha</MenuItem>
              <MenuItem value="en">English</MenuItem>
              <MenuItem value="eo">Esperanto</MenuItem>
              <MenuItem value="et">Estonian</MenuItem>
              <MenuItem value="ee">Ewe</MenuItem>
              <MenuItem value="fo">Faroese</MenuItem>
              <MenuItem value="fj">Fijian</MenuItem>
              <MenuItem value="fi">Finnish</MenuItem>
              <MenuItem value="fr">French</MenuItem>
              <MenuItem value="ff">Fulah</MenuItem>
              <MenuItem value="gl">Galician</MenuItem>
              <MenuItem value="ka">Georgian</MenuItem>
              <MenuItem value="de">German</MenuItem>
              <MenuItem value="el">Greek</MenuItem>
              <MenuItem value="gn">Guarani</MenuItem>
              <MenuItem value="gu">Gujarati</MenuItem>
              <MenuItem value="ht">Haitian</MenuItem>
              <MenuItem value="ha">Hausa</MenuItem>
              <MenuItem value="he">Hebrew</MenuItem>
              <MenuItem value="hz">Herero</MenuItem>
              <MenuItem value="hi">Hindi</MenuItem>
              <MenuItem value="ho">Hiri Motu</MenuItem>
              <MenuItem value="hu">Hungarian</MenuItem>
              <MenuItem value="is">Icelandic</MenuItem>
              <MenuItem value="io">Ido</MenuItem>
              <MenuItem value="ig">Igbo</MenuItem>
              <MenuItem value="id">Indonesian</MenuItem>
              <MenuItem value="ia">Interlingua</MenuItem>
              <MenuItem value="ie">Interlingue</MenuItem>
              <MenuItem value="iu">Inuktitut</MenuItem>
              <MenuItem value="ik">Inupiaq</MenuItem>
              <MenuItem value="ga">Irish</MenuItem>
              <MenuItem value="it">Italian</MenuItem>
              <MenuItem value="ja">Japanese</MenuItem>
              <MenuItem value="jv">Javanese</MenuItem>
              <MenuItem value="kl">Kalaallisut</MenuItem>
              <MenuItem value="kn">Kannada</MenuItem>
              <MenuItem value="kr">Kanuri</MenuItem>
              <MenuItem value="ks">Kashmiri</MenuItem>
              <MenuItem value="kk">Kazakh</MenuItem>
              <MenuItem value="km">Khmer</MenuItem>
              <MenuItem value="ki">Kikuyu</MenuItem>
              <MenuItem value="rw">Kinyarwanda</MenuItem>
              <MenuItem value="ky">Kirghiz</MenuItem>
              <MenuItem value="kv">Komi</MenuItem>
              <MenuItem value="kg">Kongo</MenuItem>
              <MenuItem value="ko">Korean</MenuItem>
              <MenuItem value="ku">Kurdish</MenuItem>
              <MenuItem value="kj">Kwanyama</MenuItem>
              <MenuItem value="lo">Lao</MenuItem>
              <MenuItem value="la">Latin</MenuItem>
              <MenuItem value="lv">Latvian</MenuItem>
              <MenuItem value="li">Limburgan</MenuItem>
              <MenuItem value="ln">Lingala</MenuItem>
              <MenuItem value="lt">Lithuanian</MenuItem>
              <MenuItem value="lu">Luba-Katanga</MenuItem>
              <MenuItem value="lg">Luganda</MenuItem>
              <MenuItem value="lb">Luxembourgish</MenuItem>
              <MenuItem value="mk">Macedonian</MenuItem>
              <MenuItem value="mg">Malagasy</MenuItem>
              <MenuItem value="ms">Malay</MenuItem>
              <MenuItem value="ml">Malayalam</MenuItem>
              <MenuItem value="mt">Maltese</MenuItem>
              <MenuItem value="gv">Manx</MenuItem>
              <MenuItem value="mi">Maori</MenuItem>
              <MenuItem value="mr">Marathi</MenuItem>
              <MenuItem value="mh">Marshallese</MenuItem>
              <MenuItem value="mn">Mongolian</MenuItem>
              <MenuItem value="na">Nauru</MenuItem>
              <MenuItem value="nv">Navajo</MenuItem>
              <MenuItem value="ng">Ndonga</MenuItem>
              <MenuItem value="ne">Nepali</MenuItem>
              <MenuItem value="nd">North Ndebele</MenuItem>
              <MenuItem value="se">Northern Sami</MenuItem>
              <MenuItem value="no">Norwegian</MenuItem>
              <MenuItem value="nb">Norwegian Bokmål</MenuItem>
              <MenuItem value="nn">Norwegian Nynorsk</MenuItem>
              <MenuItem value="oc">Occitan</MenuItem>
              <MenuItem value="oj">Ojibwa</MenuItem>
              <MenuItem value="or">Oriya</MenuItem>
              <MenuItem value="om">Oromo</MenuItem>
              <MenuItem value="os">Ossetian</MenuItem>
              <MenuItem value="pi">Pali</MenuItem>
              <MenuItem value="ps">Pashto</MenuItem>
              <MenuItem value="fa">Persian</MenuItem>
              <MenuItem value="pl">Polish</MenuItem>
              <MenuItem value="pt">Portuguese</MenuItem>
              <MenuItem value="pa">Punjabi</MenuItem>
              <MenuItem value="qu">Quechua</MenuItem>
              <MenuItem value="ro">Romanian</MenuItem>
              <MenuItem value="rm">Romansh</MenuItem>
              <MenuItem value="rn">Rundi</MenuItem>
              <MenuItem value="ru">Russian</MenuItem>
              <MenuItem value="sm">Samoan</MenuItem>
              <MenuItem value="sg">Sango</MenuItem>
              <MenuItem value="sa">Sanskrit</MenuItem>
              <MenuItem value="sc">Sardinian</MenuItem>
              <MenuItem value="sr">Serbian</MenuItem>
              <MenuItem value="sn">Shona</MenuItem>
              <MenuItem value="sd">Sindhi</MenuItem>
              <MenuItem value="si">Sinhala</MenuItem>
              <MenuItem value="sk">Slovak</MenuItem>
              <MenuItem value="sl">Slovenian</MenuItem>
              <MenuItem value="so">Somali</MenuItem>
              <MenuItem value="nr">South Ndebele</MenuItem>
              <MenuItem value="st">Southern Sotho</MenuItem>
              <MenuItem value="es">Spanish</MenuItem>
              <MenuItem value="su">Sundanese</MenuItem>
              <MenuItem value="sw">Swahili</MenuItem>
              <MenuItem value="ss">Swati</MenuItem>
              <MenuItem value="sv">Swedish</MenuItem>
              <MenuItem value="tl">Tagalog</MenuItem>
              <MenuItem value="ty">Tahitian</MenuItem>
              <MenuItem value="tg">Tajik</MenuItem>
              <MenuItem value="ta">Tamil</MenuItem>
              <MenuItem value="tt">Tatar</MenuItem>
              <MenuItem value="te">Telugu</MenuItem>
              <MenuItem value="th">Thai</MenuItem>
              <MenuItem value="bo">Tibetan</MenuItem>
              <MenuItem value="ti">Tigrinya</MenuItem>
              <MenuItem value="to">Tonga</MenuItem>
              <MenuItem value="ts">Tsonga</MenuItem>
              <MenuItem value="tn">Tswana</MenuItem>
              <MenuItem value="tr">Turkish</MenuItem>
              <MenuItem value="tk">Turkmen</MenuItem>
              <MenuItem value="tw">Twi</MenuItem>
              <MenuItem value="ug">Uighur</MenuItem>
              <MenuItem value="uk">Ukrainian</MenuItem>
              <MenuItem value="ur">Urdu</MenuItem>
              <MenuItem value="uz">Uzbek</MenuItem>
              <MenuItem value="ve">Venda</MenuItem>
              <MenuItem value="vi">Vietnamese</MenuItem>
              <MenuItem value="vo">Volapük</MenuItem>
              <MenuItem value="wa">Walloon</MenuItem>
              <MenuItem value="cy">Welsh</MenuItem>
              <MenuItem value="fy">Western Frisian</MenuItem>
              <MenuItem value="wo">Wolof</MenuItem>
              <MenuItem value="xh">Xhosa</MenuItem>
              <MenuItem value="yi">Yiddish</MenuItem>
              <MenuItem value="yo">Yoruba</MenuItem>
              <MenuItem value="za">Zhuang</MenuItem>
              <MenuItem value="zu">Zulu</MenuItem>
            </Select>
          </FormControl>

          <Button
            component="label"
            variant="outlined"
            startIcon={<CloudUploadIcon />}
            sx={{
              borderRadius: theme.shape.borderRadius,
              textTransform: 'none',
              py: 1.5
            }}
          >
            Select Video File
            <input
              type="file"
              hidden
              accept="video/*"
              onChange={(e) => setFormData(prev => ({ ...prev, videoFile: e.target.files[0] }))}
            />
          </Button>

          {formData.videoFile && (
            <Paper
              variant="outlined"
              sx={{
                p: 2,
                borderRadius: theme.shape.borderRadius,
                bgcolor: alpha(theme.palette.primary.main, 0.05)
              }}
            >
              <Typography variant="body2" color="textSecondary">
                Selected file: {formData.videoFile.name}
              </Typography>
            </Paper>
          )}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button
          onClick={() => setUploadDialog(false)}
          sx={{ textTransform: 'none' }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleVideoUpload}
          disabled={uploadLoading || !formData.videoFile}
          startIcon={uploadLoading ? <CircularProgress size={20} /> : <CloudUploadIcon />}
          sx={{
            textTransform: 'none',
            borderRadius: theme.shape.borderRadius
          }}
        >
          {uploadLoading ? 'Uploading...' : 'Upload Video'}
        </Button>
      </DialogActions>
    </Dialog>
  );

  // Main Component Return
  return (
    <MainContainer collapsed={collapsed}>
      <div style={{ marginBottom: '28px', paddingBottom: '20px', borderBottom: '1px solid var(--artemy-border)' }}>
        <h1 style={{
          fontFamily: 'var(--artemy-font-display)',
          fontSize: '24px',
          fontWeight: 700,
          color: 'var(--artemy-text-primary)',
          margin: 0,
          letterSpacing: '-0.4px'
        }}>
          <FormattedMessage id="podActivities" defaultMessage="POD Activities" />
        </h1>
        <p style={{
          fontSize: '13px',
          color: 'var(--artemy-text-secondary)',
          margin: '6px 0 0',
        }}>
          <FormattedMessage id="manageActivities" defaultMessage="Manage your Daily Pod activities and Updates" />
        </p>
      </div>
      <Stack spacing={3}>
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          sx={{ mb: 2 }}
        >
          {/* <Tooltip title={<FormattedMessage id="backToPods" defaultMessage="Back to My Pods" />}>
            <IconButton
              component={Link}
              to="/Pods"
              sx={{ 
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
                '&:hover': {
                  backgroundColor: alpha(theme.palette.primary.main, 0.2),
                }
              }}
            >
              <ArrowBackIcon />
            </IconButton>
          </Tooltip>
          <Breadcrumbs>
            <Link
              to="/Pods"
              style={{
                color: theme.palette.primary.main,
                textDecoration: 'none',
                fontWeight: 600,
              }}
            >
              <FormattedMessage id="myPods" defaultMessage="My Pods" />
            </Link>
          </Breadcrumbs> */}
        </Stack>
        {renderPodSelector()}
        <div style={{ display: 'flex', gap: '8px', marginBottom: '32px', backgroundColor: 'rgba(255,255,255,0.03)', borderRadius: '16px', padding: '8px', border: '1px solid var(--artemy-border)' }}>
          <button
            className={`artemy-btn ${tabValue === 0 ? '' : 'artemy-btn-ghost'}`}
            onClick={() => setTabValue(0)}
            style={{
              minHeight: '48px',
              borderRadius: '12px',
              flex: 1,
              justifyContent: 'center',
              backgroundColor: tabValue === 0 ? 'var(--artemy-primary)' : 'transparent',
              color: tabValue === 0 ? '#fff' : 'var(--artemy-text-secondary)',
              border: 'none',
              fontSize: '14px'
            }}
          >
            <AssignmentIcon sx={{ mr: 1, fontSize: 20 }} />
            <FormattedMessage id="postActivity" defaultMessage="Post Activity" />
          </button>
          <button
            className={`artemy-btn ${tabValue === 1 ? '' : 'artemy-btn-ghost'}`}
            onClick={() => setTabValue(1)}
            style={{
              minHeight: '48px',
              borderRadius: '12px',
              flex: 1,
              justifyContent: 'center',
              backgroundColor: tabValue === 1 ? 'var(--artemy-primary)' : 'transparent',
              color: tabValue === 1 ? '#fff' : 'var(--artemy-text-secondary)',
              border: 'none',
              fontSize: '14px'
            }}
          >
            <DashboardIcon sx={{ mr: 1, fontSize: 20 }} />
            <FormattedMessage id="viewActivities" defaultMessage="View Activities" />
          </button>
        </div>
      </Stack>

      <Fade in={true}>
        <Box>
          {tabValue === 0 ? renderActivityForm() : (
            <>
              {renderFilters()}
              {renderActivitiesTable()}
            </>
          )}
        </Box>
      </Fade>

      {renderUploadDialog()}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          variant="filled"
          sx={{ borderRadius: theme.shape.borderRadius }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      {renderViewDialog()}
      {renderEditDialog()}
      {renderOpenAITokenDialog()}
    </MainContainer>
  );
};

export default PodActivityTalent;
